// extracted by mini-css-extract-plugin
module.exports = {"root":"_340441","title":"_a2f243","inline":"_c8d184","rating":"_a54f25","content":"_ea7c97","snippetContainer":"_e6ee12","snippet":"_8e78c2","pagination":"_6382d1"};